import { render, staticRenderFns } from "./AppPushIcon.vue?vue&type=template&id=1927836a&"
import script from "./AppPushIcon.vue?vue&type=script&lang=js&"
export * from "./AppPushIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports